export const PAYMENT_CANCEL_REQUEST_STATUSES = {
  WAITING: '처리 대기',
  CANCELED: '결제 취소 완료',
  REJECTED: '결제 취소 불가',
};
